import { handleError } from '../../../../store/features/alertSlice';
import commentsService from '@rd-web-markets/shared/dist/services/comments.service';
import React, { useCallback, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { Button } from '../../../buttons';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
export default function CreateComment(_ref) {
  let {
    textSelection,
    modelClass,
    modelId,
    modelField,
    onCreateComment,
    spanId
  } = _ref;
  const [newCommentText, setNewCommentText] = useState('');
  const [commentBtnLoading, setCommentBtnLoading] = useState(false);
  const createComment = useErrorHandling(useCallback(async (spanId, modelClass, modelId, onCreateComment) => {
    setCommentBtnLoading(true);
    await commentsService.create(modelId, modelClass, {
      body: newCommentText,
      span_id: spanId,
      field: modelField
    });
    const result = await commentsService.all(modelId, modelClass, spanId, modelField);
    onCreateComment(result.comments);
    setNewCommentText('');
  }, [modelField, newCommentText]), useCallback(() => {
    setCommentBtnLoading(false);
  }, []));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 11
  }, /*#__PURE__*/React.createElement(Form.Control, {
    style: {
      resize: 'none'
    },
    as: "textarea",
    rows: "3",
    size: "sm",
    value: newCommentText,
    onChange: e => setNewCommentText(e.target.value)
  })), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Button, {
    icon: "chevron_right",
    onClick: () => {
      createComment(spanId, modelClass, modelId, onCreateComment);
    },
    loading: commentBtnLoading,
    showLoadingText: false
  }))));
}